<template>
  <div>
    <header-div v-if="isshow"></header-div>
    <orgheader-div v-else></orgheader-div>
    <div class="container">
      <div class="xieyi">
        <br>
        <br>
        <br>

        <h2>平台介绍</h2>
        <div class="xieyi-content">
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <strong><span style="font-family:宋体;color:black;background:white">以满足学会发展需求为服务导向，以整合优化各类社会资源为切入点的学会服务“智汇”平台，是中国科协学会服务中心坚持“四服务”职能定位，为学会倾心打造的集合理论学习和业务交流的综合服务平台。平台通过为学会用户量身定制专属课程、专题培训、专家问答、和实用手册四位一体线上服务，是一个使用便捷、内容丰富、实用性强、兼具深度及广度的学习平台。</span></strong>
          </p>
        </div>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <h2>版权声明</h2>
        <div class="xieyi-content">
          <p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left: 0;background:white">
            <strong><span style="font-family:宋体;color:black;background:white">本平台发布的文章、信息、视频、图片仅供您个人学习、阅读使用，未经学会服务“智汇”平台的书面许可，任何单位及个人不得将内容用于商业用途，包括但不限于复制、修改、传送、出版等方式，否则将依法追究侵权者的法律责任。</span></strong>
          </p>
        </div>
      </div>
    </div>
    <footer-div v-if="isshow"></footer-div>
    <orgfooter-div v-else></orgfooter-div>
  </div>
</template>

<script>
  import headerDiv from '../pageMember/components/header'
  import footerDiv from '../pageMember/components/footer'
  import orgheaderDiv from '../pageOrg/components/header'
  import orgfooterDiv from '../pageOrg/components/footer'

  export default {
    data() {
      return {
        content: '',
        isshow: false
      }
    },
    created() {
      // 默认选择北京市
      this.$store.state.selectionAddress = window.sessionStorage.getItem('selectionAddress') ? JSON.parse(window.sessionStorage.getItem('selectionAddress')) : {
        categoryname: "北京市",
        city_id: 110100,
        parentid: 1,
        spell: "beijingshi"
      }
      if(JSON.parse(window.localStorage.getItem('user')) === null) {
        this.isshow = true
      }else{
        JSON.parse(window.localStorage.getItem('user')).user_type !== 2 ? this.isshow = true : this.isshow = false
      }

    },
    methods: {
      getCookie(cname) {
        let name = cname + "="
        let ca = document.cookie.split(';')
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i].trim()
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
          }
        }
        return ""
      }
    },
    components: {
      headerDiv,
      footerDiv,
      orgheaderDiv,
      orgfooterDiv
    }
  }
</script>

<style scoped lang="scss">
  .xieyi {
    min-height: 500px;
    padding: 30px 20px;
    background: #fff;
    margin: 30px 0;

    > h2 {
      text-align: center;
      font-size: 20px;
      line-height: 60px;
    }

    .xieyi-content {
      p, div, h1, h2, h3, h4, h5, h6 {
        line-height: 24px;
      }
    }
  }
</style>